<div class="skills-container">
  <div id="container" class="container">
    <h1 [@slideInUp]="slideInUp">My Skills</h1>
    <div class="flex-skill">
      <div [@fadeInLeft]="fadeInLeft" class="skill-primary">
        <div class="skill">
          <h3 class="skill-name">
            Angular&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </h3>
          <mat-slider class="mat-slider skill-slider cdk-focused" [thumbLabel]="thumbLabel" [(ngModel)]="pythonValue">
          </mat-slider>
        </div>
        <div class="skill">
          <h3 class="skill-name">MongoDB</h3>
          <mat-slider class="mat-slider skill-slider cdk-focused" [thumbLabel]="thumbLabel" [(ngModel)]="machineValue">
          </mat-slider>
        </div>
        <div class="skill">
          <h3 class="skill-name">SQL</h3>
          <mat-slider class="mat-slider skill-slider cdk-focused" [thumbLabel]="thumbLabel" [(ngModel)]="sqlValue">
          </mat-slider>
        </div>
        <div class="skill">
          <h3 class="skill-name">Git & GitHub</h3>
          <mat-slider class="mat-slider skill-slider cdk-focused" [thumbLabel]="thumbLabel" [(ngModel)]="gitValue">
          </mat-slider>
        </div>
        <div class="skill">
          <h3 class="skill-name">Data Structures</h3>
          <mat-slider class="mat-slider skill-slider cdk-focused" [thumbLabel]="thumbLabel"
            [(ngModel)]="datastructuresValue">
          </mat-slider>
        </div>
      </div>
      <div [@fadeInRight]="fadeInRight" class="skill-secondary">
        <div class="skill">
          <h3 class="skill-name">Python Flask</h3>
          <mat-slider class="mat-slider skill-slider cdk-focused" [thumbLabel]="thumbLabel" [(ngModel)]="pythonValue">
          </mat-slider>
        </div>
        <div class="skill">
          <h3 class="skill-name">Machine Learning and AI&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h3>
          <mat-slider class="mat-slider skill-slider cdk-focused" [thumbLabel]="thumbLabel" [(ngModel)]="machineValue">
          </mat-slider>
        </div>
        <div class="skill">
          <h3 class="skill-name">SQL</h3>
          <mat-slider class="mat-slider skill-slider cdk-focused" [thumbLabel]="thumbLabel" [(ngModel)]="sqlValue">
          </mat-slider>
        </div>
        <div class="skill">
          <h3 class="skill-name">Git & GitHub</h3>
          <mat-slider class="mat-slider skill-slider cdk-focused" [thumbLabel]="thumbLabel" [(ngModel)]="gitValue">
          </mat-slider>
        </div>
        <div class="skill">
          <h3 class="skill-name">Data Structures</h3>
          <mat-slider class="mat-slider skill-slider cdk-focused" [thumbLabel]="thumbLabel"
            [(ngModel)]="datastructuresValue">
          </mat-slider>
        </div>
      </div>
    </div>
    <h1 [@slideInUp]="slideInUp">I'm Also Good @</h1>
    <div [@fadeInDown]="fadeInDown" class="other-skills">
      <div class="others-flex">
        <span class="material-icons">
          fast_forward
        </span>
        <h4>Team Building and Collaborative</h4>
      </div>
      <div class="others-flex">
        <span class="material-icons">
          fast_forward
        </span>
        <h4>Reliable and Consistency</h4>
      </div>
      <div class="others-flex">
        <span class="material-icons">
          fast_forward
        </span>
        <h4>Commited to Life long Learning</h4>
      </div>
    </div>
  </div>
</div>
